import React, { useEffect, useState, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { ReactComponent as UploadFileIcon } from "../../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as FormIcon } from "../../../../Icons/CommonFormIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../api/axiosInstance";

export default function Agreement({ setStepperCount }) {
  const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
  } = useForm({
    mode: "onTouched",
  });

  const navigate = useNavigate();
  const data = useSelector((state) => state.AdminData.admin);
  const [allData, setAllData] = useState({});
  const [checked, setChecked] = useState(false);

  const Imgwatch = watch("img");

  const imgFile = useRef();

  const [bgImg, setBgImg] = useState([]);

  useEffect(() => {
    if (Boolean(Imgwatch)) {
      setBgImg((prev) => []);

      Array.from(Imgwatch)?.map((item, index) =>
        setBgImg((prev) => [...prev, { id: index + 1, img: item }])
      );
    }
  }, [Imgwatch]);

  const fetchData = async () => {
    await axiosInstance
      .get(`${process.env.REACT_APP_API_URL}get-paiduser-by-id/${data.id}`)
      .then((response) => {
        console.log(response, "paid user");
        if (response.status === 200) {
          if (response?.data?.data.tenancyAgreement) {
            setValue("name", response?.data?.data?.tenancyAgreement.name);
            setValue(
              "passport",
              response?.data?.data?.tenancyAgreement.passport_no
            );
            setValue(
              "finnumber",
              response?.data?.data?.tenancyAgreement.fin_no
            );
            setValue("img", [response?.data?.data?.tenancyAgreement.signature]);
            setChecked(response.data.data.tenancyAgreement.agreement);
          } else {
            setValue("name", response?.data?.data?.PersonalData?.Details?.name);
            setValue(
              "passport",
              response?.data?.data?.PersonalData?.Details?.passport_no
            );
          }
          setAllData(response.data.data);
        }
      })
      .catch((error) => console.log(error));
  };

  // const fetchTenancyAgreement = async () => {
  //     await axios.get(`${process.env.REACT_APP_API_URL}get-tenancy-agreement/${data.id}`)
  //     .then((response) => {
  //       console.log(response)
  //     }).catch((error) => {
  //       console.log(error)
  //     })
  // }

  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:  return 'st';
      case 2:  return 'nd';
      case 3:  return 'rd';
      default: return 'th';
    }
  };
  
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString('default', { month: 'long' }); // March, April, etc.
  const year = today.getFullYear();
  const dayWithSuffix = `${day}${getDaySuffix(day)}`;

  useEffect(() => {
    if (data?.id) {
      fetchData();
    }
  }, []);

  const handleChange = () => {
    setChecked(!checked);
  };

  const onSubmit = async (dataa) => {
    console.log(dataa);
    const sendObj = new FormData();
    sendObj.append("name", dataa?.name);
    sendObj.append("fin_no", dataa?.finnumber);
    sendObj.append("passport_no", dataa?.passport);
    sendObj.append("signature", dataa?.img[0]);
    sendObj.append("agreement", checked);
    await axiosInstance
      .put(
        `${process.env.REACT_APP_API_URL}add-tenancy-agreement/${data.id}`,
        sendObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          setStepperCount(2);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteFirstImage = (id) => {
    let updatedFiles = Array.from(Imgwatch);
    updatedFiles = updatedFiles.filter((file, index) => index !== id);
    setValue("img", updatedFiles);
  };

  return (
    <Box px={{ md: 10, xs: 3 }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography
          sx={{ pb: 4, ":hover": { cursor: "pointer" } }}
          onClick={() => navigate("/account")}
        >
          <ArrowBackIcon sx={{ fontSize: "30px" }} />
        </Typography>
        <Typography variant="h6_1">Tenancy Agreement</Typography>
        <Grid mt={3} mb={6} container rowGap={7}>
          <Grid
            xs={12}
            sx={{ display: "flex", flexDirection: "column" }}
            rowGap={2}
            gap={2}
          >
            <Divider />
            <Stack
      direction="row"
      alignItems="center"
      sx={{ fontSize: "20px", fontWeight: 500 }}
      gap={1}
    >
      THIS AGREEMENT is made on the{" "}
      <Typography variant="h7_1">{dayWithSuffix}</Typography> day of{" "}
      <Typography variant="h7_1">{month}, {year}</Typography>
    </Stack>
            <Grid mt={3} container justifyContent="start" columnGap={4}>
              <Grid xs={12} sm={4} rowGap={2}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography color="#1A2461" variant="h7_1">
                    PARTY A
                  </Typography>
                  <InputLabel sx={{ marginBottom: "0px" }} variant="standard">
                    (“the Landlord/Licensor”)
                  </InputLabel>
                </Stack>
                <Stack mt={3} direction="column" alignItems="start" gap={1}>
                  <Typography color="#1A2461" variant="h7_1">
                    Singapore Vinga International Pte Ltd
                  </Typography>
                  <InputLabel
                    sx={{ marginBottom: "0px", color: "#1A2461 !important" }}
                    variant="standard"
                  >
                    Vinga Hall <br />
                    Address: No. 99 Rangoon Road, Singapore 218384
                    <br />
                    UEN: 200516098N
                  </InputLabel>
                </Stack>
              </Grid>
              <Grid xs={12} sm={4}>
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography color="#1A2461" variant="h7_1">
                    PARTY B
                  </Typography>
                  <InputLabel sx={{ marginBottom: "0px" }} variant="standard">
                    (“the Student”)
                  </InputLabel>
                </Stack>

                <InputLabel
                  sx={{
                    mt: 2,
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.name ? "Full name*" : "Full name"}
                </InputLabel>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      placeholder="Enter name"
                      error={Boolean(errors?.name) ? true : false}
                      {...field}
                      sx={{
                        width: "100%",
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.name ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.name
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.name
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.name
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.name ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter name
                  </Typography>
                ) : null}

                <InputLabel
                  sx={{
                    mt: 2,
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.passport ? "Passport Number*" : "Passport Number"}
                </InputLabel>
                <Controller
                  name="passport"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      placeholder="Enter Passport Number"
                      error={Boolean(errors?.passport) ? true : false}
                      {...field}
                      sx={{
                        width: "100%",
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.passport ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.passport
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.passport
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.passport
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.passport ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter Passport number
                  </Typography>
                ) : null}

                <InputLabel
                  sx={{
                    mt: 2,
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.finnumber ? "FIN number*" : "FIN number"}
                </InputLabel>
                <Controller
                  name="finnumber"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      placeholder="Enter FIN Number"
                      error={Boolean(errors?.finnumber) ? true : false}
                      {...field}
                      sx={{
                        width: "100%",
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.finnumber ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.finnumber
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.finnumber
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.finnumber
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.finnumber ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter FIN number
                  </Typography>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} sx={{ display: "flex", flexDirection: "column" }}>
            <Stack
              textAlign="center"
              sx={{
                border: "1px solid #1A2461",
                width: "100%",
                borderRadius: "8px",
                padding: "40px 60px",
                height : '400px',
                overflowY : 'scroll'
              }}
            >
              <Stack gap={1}>
                <Typography variant="h6_1">Agreement Terms</Typography>
                <Typography color="#1A2461" variant="h9_4">
                  The Student will check-in to Vinga Hall, Address: 99 Rangoon
                  Road, Singapore 218384, bothparties come into agreed terms as
                  follows:
                </Typography>
              </Stack>
              <Stack
                mt={5}
                gap="10px"
                direction="column"
                alignItems="start"
                textAlign="start"
              >
                <Typography variant="h6_1">
                  1. PARTY A (Landlord) responsibilities
                </Typography>
                <Typography color="#1A2461" variant="h9_4">
                  (1) Party A allows the Student to stay in Vinga Hall address,
                  and promises to monitor on the Student’s activities during the
                  stay,
                  <br />
                  (2) Party A agrees to provide the Student, a room with bed,
                  mattress, wardrobe, bookshelves and writing desk, to ensure
                  the Student stays in a clean, comfortable and conducive
                  environment.
                  <br />
                  (3) Party A reserves the right to allocate and to change room
                  for the Student anytime.
                  <br />
                  (4) Party A offers free Wifi & LAN internet facilities inside
                  the room.
                  <br />
                  (5) Party A provides free air-con, electricity and water
                  supply.
                  <br />
                  (6) Party A provides free laundry services twice weekly.
                  <br />
                  (7) Party A provides daily general room cleaning services and
                  twice weekly specific cleaning.
                  <br />
                  (8) Party A will bring new student to get familiar with the
                  living environment. If the Student is sick, Party A will take
                  initiative to take care of the Student and to inform the
                  Parents, or guardian in Singapore. If needed, assists to bring
                  the Student to see doctor. All transport and doctor
                  consulatation expenses will be borned by the Student.
                  <br />
                  (9) Party A will report to the Parents or guardian in
                  Singapore daily, through Wechat groupchat at around 10pm
                  regarding the Student’s status.
                  <br />
                  (10) Party A will promptly reply the Parents or guardian in
                  Singapore any enquiry related to the Student’s living condition
                  or his/her status.
                  <br />
                  (11) Party A will manage cash allowance, if the Parents opted
                  for the service, and will distribute the allowance weekly on
                  time with the agreed sum.
                  <br />
                  (12) Party A will provide airticket advanced booking service
                  free of charge.
                  <br />
                  (13) Party A will provide the Student with counseling services
                  on living overseas or education related matters. Facilitate the
                  Student to successfully completed his/her study and to
                  maintain a healthy lifestyle.
                  <br />
                  (14) Party A will provide local school transfer consultation
                  service free of charge, and to give advice to the Student on
                  overseas study matters.
                  <br />
                  (15) Party A will also provide migration consultation service
                  free of charge.
                </Typography>
              </Stack>

              <Stack
                mt={5}
                gap="10px"
                direction="column"
                alignItems="start"
                textAlign="start"
              >
                <Typography variant="h6_1">
                   2. Party B (Parents and/or Tenant/Student) responsibilities
                </Typography>
                <Typography color="#1A2461" variant="h9_4">
                  (1) Party B agrees, within this agreement validity, while studying in Singapore, to stay in
Vinga Hall.
                  <br />
                  (2) Party B will have to follow the terms of this agreement, to pay the room rental fee and the room rental deposit on time.
                  <br />
                  (3) Party B will have to declare the Student’s health condition, any food allergy, drug allergy, as well as the treatment of these allergies.
                  <br />
                  (4) Party B has to strictly adhere to Singapore law and regulations. 
                  <br />
                  (5) Party B has to follow school rules and Vinga Hall rules.
                  <br />
                  (6) Party B must be punctual when attending school and returning to Vinga Hall. In case, if the Student is unable to return home from school on time, he/she must notice Hostel Management in advance, and to seek approval with a valid reason.
                  <br />
                  (7) Party B has to obey all rules and regulations set by Vinga Hall Management, and to live
harmoniously with other residents.
                  <br />
                  (8) Party B is not allowed to create any disturbance to other residents, in particular, noise, within Vinga Hall. Party B must learn to be considerate to other residents.
                  <br />
                  (9) Party B has to follow the assigned rest time, meal time and self study time.
                  <br />
                  (10) Party B has to protect the property of Vinga Hall, Party B will have to compensate for any property being damaged.
                  <br />
                  (11) Party B should approach Vinga Hall Management for safe-keeping of cash or valuables, Vinga Hall Management will not be responsible for any loss.
                  <br />
                  (12) Party B should avoid wastage of water and electricity. Aircon, lightings, computers andother electrical appliances must be turned off when the Student is not in the room.
                  <br />
                  (13) Party B needs to purchase adequate medical insurance during the time studying in
Singapore.
                  <br />
                  (14) Party B is not allowed to bring or to consume any alcohol, tobacco or drug in Vinga Hall.
                  <br />
                  (15) Party B is not allowed to cook inside the room, high voltage of electricity usage may leadto electric short curcuit. In such case, Party B will have to bear the consequences. Any personal
electrical item to be placed in the room will be subject to Vinga Hall Management approval.
                  (16) Party B must follow the rules of Vinga Hall, in terms of resting and sleeping time. In case, if the Student has to be back late with a valid reason, the Student must give advanced notice to
Vinga Hall Management and the guardian in Singapore.
                  <br />
                  (17) If the Student is below the age of 18, he/she must return to Vinga Hall by 6pm, the latest.
                  <br />
                  (18) Party B is not allowed to bring friends, schoolmates, to visit Vinga Hall at all times.
                  <br />
                  (19) If Party B committed any offence in school or in Singapore, causing deportation or student
pass termination, This tenancy agreement will be immediately terminated, and there will be no refund at all from Party A, Moreover, Party B will have to pay back the unpaid rental amount.
                  <br />
                  (20) Party B will still have to pay for full rental when going away for holiday, tour trips or
sleep-out within the contract period.
                  <br />
                  (21) Party A is not responsible for the Student’s bedding accessories, including bedsheet. Please refer to our standard bunk bed size: 120W x 190L x 15H when Party B purchasing own bedsheets. 
                  <br />
                  (22) Party B who fails to comply with any of the above terms or rules, shall be subject to
disciplinary action or fine being imposed by Vinga Hall Management.
                  <br />
                </Typography>
              </Stack>

              <Stack
                mt={5}
                gap="10px"
                direction="column"
                alignItems="start"
                textAlign="start"
              >
                <Typography variant="h6_1">
                    3. Rental Payment & Deposit
                </Typography>
                <Typography color="#1A2461" variant="h9_4">
                  (1) Rental payment should be an one-off settlement. For a 2-year agreement, it can be settled on a yearly basis. Total rental payment at
                  <br />
                  (2) Upon signing of agreement, Party B must pay a rental deposit, equivalent to 1-month rental
charge, at
When this agreement expiring, the room condition will have to be the same as move-in condition, except fair wear and tear. In such case, full deposit will be refunded (without interest) to Party B. Whereby, if there is any property damaged in the room, Party B will have to compensate for the
damage or loss, based on the price fixed in the signed checklist, and it will be deducted accordingly from the rental deposit. Vinga Hall Management reserves the right to pursue any additional
compensation whereby the rental deposit is not sufficient to cover the total cost of damage or loss.
                  <br />
                  (3) The rental deposit paid upon the signing of agreement will not be allowed to offset the
monthly rental payment.
                  <br />
                  (4) If the rental payment is not settled by Party B on the due date, a penalty of 1%daily
interest rate will be imposed on Party B, maximum cap at 10%. If the rental payment cannot be
settled within 10 days from the due date, Party A reserves the right to terminate the Agreement, at
any time, without further notice. 
                  <br />
                  (5) If Party B did not fulfil the signed agreement’s full period of stay, Party A reserves the
right not to return the paid rental amount to Party B, but Party A will refund the rental deposit to Party B, provided that no damage is found in the room.
                  <br />
                  (6) Upon agreement expiration, if Party B decided not to renew the lease, Party B must fill upthe Check-Out notice form (see attached) one month before the agreement expiry date, and submit
to Vinga Hall Management. Failure to do so will result in the rental deposit not being refunded.
                  <br />
                  (7) One month before the agreement is expiring, Party B must give full 1-month advancednotice, either to continue staying in Vinga Hall or to move out. Without notice given by Party B, the agreement will be automatically renew with the same duration as the previous agreement.
                  <br />
                  (8) Party A reserves the right not to renew the agreement with Party B upon agreement
expiration, on a case by case basis.
                  <br />
                </Typography>
              </Stack>

              <Stack
                mt={5}
                gap="10px"
                direction="column"
                alignItems="start"
                textAlign="start"
              >
                <Typography variant="h6_1">
                    4. Additional term & Amendment
                </Typography>
                <Typography color="#1A2461" variant="h9_4">
                  (1) Any supplement, change or amendment of this agreement, must be in written format, with both parties’ signatures, in order to be effective.
                  <br />
                </Typography>
              </Stack>

              <Stack
                mt={5}
                gap="10px"
                direction="column"
                alignItems="start"
                textAlign="start"
              >
                <Typography variant="h6_1">
                5. Commencement & Ceasation of agreement terms
                </Typography>
                <Typography color="#1A2461" variant="h9_4">
                  (1) This agreement will take effect on the day that both Party A and Party B signed and
stamped on the agreement.
                  <br />
                  (2) This agreement has 2 original copies, both Party A and Party B keeps one copy each.
                  <br />
                  (3) This agreement will consider ended, after both parties fulfilled their own obligations and responsibilities.
                  <br />
                </Typography>
              </Stack>


            </Stack>
            <Stack
              mt={2}
              gap="5px"
              direction="row"
              alignItems="center"
              justifyContent="start"
            >
              <Checkbox checked={checked} onChange={handleChange} />
              <Typography variant="h9_3">
                I have read the contract and I agree with the terms and
                conditions
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Box>
          <InputLabel
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: "rgba(26, 36, 97, 1)",
            }}
          >
            Signed by
          </InputLabel>
          {Boolean(Imgwatch?.length > 0) ? (
            Array.from(Imgwatch)?.map((item, index) => (
              <Box style={{ padding: "0px 17px 17px" }}>
                <Stack
                  mt={2}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  padding="23px"
                  borderRadius="8px"
                  sx={{ border: ".5px solid #1A2461" }}
                >
                  <Typography
                    variant="h9_1"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <ImgIcon />
                    {item?.name || item?.originalname}
                  </Typography>
                  <ClearIcon
                    onClick={() => deleteFirstImage(index)}
                    sx={{ color: "#1A2461" }}
                  />
                </Stack>
              </Box>
            ))
          ) : (
            <Box
              xs={12}
              onClick={() => imgFile.current.click()}
              sx={{
                border: Boolean(errors.img)
                  ? "1px dashed red"
                  : "1px dashed #1A2461",
                height: "200px",
                borderRadius: "8px",
                backgroundColor: "#F9FBFF",
                margin: "20px 17px 17px",
              }}
            >
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                height="100%"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "100px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <UploadFileIcon fill="#1A2461" />
                </Stack>
                <Stack mt={2} direction="row" alignItems="center" gap="5px">
                  <Typography variant="h9_1">Click to upload</Typography>
                </Stack>
                <Typography variant="h9_5">
                  Allowed formats - JPEG, PNG
                </Typography>
              </Stack>
              <Box sx={{ marginTop: "0.3rem" }}>
                {errors?.img ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please select an Image
                  </Typography>
                ) : null}
              </Box>
            </Box>
          )}
          <Controller
            name="img"
            rules={{ required: true }}
            control={control}
            render={({ field }) => (
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  field.onChange(e.target.files);
                }}
                ref={(e) => {
                  imgFile.current = e;
                }}
                hidden
                multiple
              />
            )}
          />
        </Box>

        <Stack
          my={5}
          direction="row"
          alignItems="center"
          justifyContent="end"
        >
          <Button disabled={!checked} type="submit" variant="standard">
            Continue
          </Button>
        </Stack>
      </form>
    </Box>
  );
}
